



















import { notify } from 'mycorems-app-shared';
import HasTaskMixin from '../../components/HasTaskMixin';
import { reinvite } from '../invite';

export default HasTaskMixin.extend({
  props: {
    userId: {
      type: String,
      required: true,
    },
  },
  methods: {
    resend() {
      this.task = reinvite(this.userId);
      this.task.then(() => {
        notify.success('Invitation has been sent.');
      });
    },
  },
});
